module.exports = __webpack_public_path__ + "img/ic_notification_premium-inactive.f61ccc90.svg";